import { useSelector } from "react-redux";

export default function BannerRodape(props) {
  const user = useSelector((state) => state.user);

  return (
    <>
      <div style={{ maxWidth: "100%", display: "flex" }}>
        {user?.logos?.banner && (
          <img
            src={user.logos.banner}
            alt=""
            style={{
              maxWidth: "100%",
              margin: "auto",
            }}
            {...props}
          />
        )}
      </div>
    </>
  );
}
